import { SWRConfiguration } from 'swr';

import { useArraySWR } from '~/hooks/useSWR';
import { fetchFromNewApi } from '~/services/Http';
import { APIs } from '~/services/Http/internalAPIs';
import { GridTemplateListItem } from '~/types/forms';

export const useFormTemplatesList = (swrConfig?: SWRConfiguration) => {
  return useArraySWR<GridTemplateListItem>(
    ['getAllFormTemplates'],
    () =>
      fetchFromNewApi(APIs.forms.getAllForms(), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }).then((r) => r.json()),
    { revalidateOnFocus: false, ...swrConfig },
  );
};
